var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"absolute":"","color":"transparent","flat":"","height":"85"}},[_c('v-container',{staticClass:"px-0 text-right d-flex align-center"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }